module.exports = __webpack_public_path__ + "img/ic-navigation-white.2687d288.svg";